import { render, staticRenderFns } from "./WorkflowSelectPreferredObjectStore.vue?vue&type=template&id=2381e4d6"
import script from "./WorkflowSelectPreferredObjectStore.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowSelectPreferredObjectStore.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports